import { FC, useState } from 'react';
import clsx from 'clsx';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import styles from '../styles.module.css';
import { navGroups } from '../../../routes/config';
import NavbarGroup from './group';

const Navbar: FC = () => {

  const [ isOpen, setIsOpen ] = useState(false);

  // TODO: simple toggle at this point, should implement checks for
  // resetting state as needed in the event that someone resizes the window

  const toggleIsOpen = () => {
    setIsOpen(current => !current);
  };

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">

        <img src="/images/logo-vhg.svg" alt="Limbic Logo" className={styles.logo} />

        {/* eslint-disable-next-line */}
        <a role="button" className={clsx('navbar-burger', isOpen ? 'is-active' : '')} aria-label="menu" aria-expanded="false" data-target="navbarMain" onClick={toggleIsOpen}>
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>

      <div id="navbarMain" className={clsx('navbar-menu', isOpen ? 'is-active' : '')}>
        <div className="navbar-start">
          <span className={clsx('navbar-item', styles.navbarTitle)}>
            <span>Clinic Admin Portal - by Limbic</span>
            <img src="/images/logo-limbic.png" alt="Limbic Logo" className={styles.logoLimbic} />
          </span>
        </div>

        <div className="is-hidden-desktop">

          {navGroups.map((navGroup, i) => (
            <NavbarGroup key={i} group={navGroup.group} routes={navGroup.routes} />
          ))}

          <a className="navbar-item" href="">
            Logout
          </a>

        </div>

        <div className="navbar-end is-hidden-touch">
          <div className="navbar-item has-dropdown is-hoverable">
            <span className="navbar-link is-arrowless" style={{ padding: '0 20px' }}>
              <FontAwesomeIcon icon={faUser as IconProp} size="lg" />
            </span>

            <div className="navbar-dropdown is-right">
              <a className="navbar-item" href="">
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );

};

export default Navbar;
